/**
 * Revamp cart drawer: the minus button removes the line item when the
 * quantity is 1 (the theme's QuantityInput clamps at min="1", so that click
 * is otherwise a silent no-op). Capture phase is required: the button's own
 * handler decrements the input before bubble listeners run, so only capture
 * sees the pre-click value. Removal goes through the theme's own debounced
 * <cart-items> change pipeline (same path as the remove link).
 */
if (!window.revampCartQtyRemoveBound) {
  window.revampCartQtyRemoveBound = true;

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const button = event.target.closest('.revamp-line__qty-btn[name="minus"]');
    if (!button || button.disabled) return;

    const stepper = button.closest('cart-quantity');
    const cartItems = button.closest('cart-items');
    const input = stepper ? stepper.querySelector('input[data-index]') : null;
    if (!cartItems || !input) return;

    if ((parseInt(input.value, 10) || 1) > 1) return;

    // Keep the click off QuantitySelector — its clamp would bounce "0" back to "1".
    event.stopPropagation();

    // Freeze the row until the re-render: a second change from it would POST
    // a stale line index and remove/alter the wrong line.
    for (const b of stepper.querySelectorAll('button')) b.disabled = true;
    input.readOnly = true;

    input.value = '0';
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }, { capture: true });
}
